import React from 'react';

import { displayDate } from '../../utils/DateUtils';
import NeoHistoryCard from './NeoHistoryCard';
import { SessionHistory } from './NeoLeoHistoryIndex';

interface NeoLeoHistoryByDayCardProps {
  history: SessionHistory[];
  hideHistory(): void;
}

const NeoLeoHistoryByDayCard: React.FC<NeoLeoHistoryByDayCardProps> = ({
  history,
  hideHistory,
}) => (
  <div
    className='flex flex-col mb-5'
    data-testid={`history-card-by-day-${displayDate(history[0].start_time)}`}
  >
    <p className='flex-grow text-reskin-regent-600 text-sm font-medium font-inter'>
      {displayDate(history[0].start_time)}
    </p>
    <div className='flex-grow'>
      {history.map((historyData) => (
        <NeoHistoryCard
          key={historyData.id}
          hideHistory={hideHistory}
          {...historyData}
        />
      ))}
    </div>
  </div>
);

export default NeoLeoHistoryByDayCard;
